import { combineReducers } from "redux";
import user from "./user";
import language from "./language";
import theme from "./theme";
import notification from "./notification";
import Themes from "./Themes";
import strategicObjective from "./strategicObjective";
import KPIs from "./KPIs";
import perspective from "./perspective";
import pillar from "./pillar";
import strategy from "./strategy";
import subStrategicObjective from "./subStrategicObjective";
import taskCenter from "./taskCenter";

export default combineReducers({
  user,
  theme,
  notification,
  Themes,
  language,
  strategicObjective,
  KPIs,
  perspective,
  pillar,
  strategy,
  subStrategicObjective,
  taskCenter,
});
